//Temporary solution... This is one dumb solution.

class CssManager {
    constructor() {
        this._initialize();
    }

    private _initialize() {

        //Toolbar start
        var styles = '.vt-container{z-index:500;display:inline-block;}';
        styles += '.vt-container >.vt-section:first-child >.vt-item:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px;}';
        styles += '.vt-container >.vt-section:last-child >.vt-item:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px;}';
        styles += '.vt-container >.vt-section{position:relative;display:inline-block;border-left: 1px solid #afb6bf}';
        styles += '.vt-container >.vt-section:first-child{border-left: none;}';
        styles += '.vt-item{position:relative;display:table-cell;padding:10px;background-color:#0A8FCC;}';
        styles += '.vt-item span{font-size:14px;color:#e3e3e3;vertical-align:middle;display:table-cell;padding-left:10px;}';
        styles += '.vt-item-toggle{position:relative;display:table-cell;padding:10px;background-color:#0A8FCC;cursor:pointer;}';
        styles += '.vt-item-toggle img{background-color:#dbdee2;width:28px;height:28px;}';
        styles += '.vt-item-toggle img:hover{background-color:#09A3EF;cursor:pointer;}';
        styles += '.vt-item-toggle img:active{background-color:#0CAAF2;}';
        styles += '.vt-item-toggle.selected img{background-color:#67b2e8;}';
        styles += '.vt-item-cmd{position:relative;display:table-cell;padding:10px;background-color:#0A8FCC;cursor:pointer;}';
        styles += '.vt-item-cmd img{width:28px;height:28px;}';
        styles += '.vt-item-cmd:hover{background-color:#09A3EF;}';
        styles += '.vt-item-cmd:active{background-color:#0CAAF2;}';
        styles += '.vt-item-cmd.selected{background-color:#67b2e8;}';
        styles += '.vt-item-ctn{display:table-row;}';
        styles += '.vt-item-ctn img{vertical-align:middle;}';
        styles += '.vt-group{position:relative;display:table-cell;background-color:#0A8FCC;cursor:pointer;}';
        styles += '.vt-group img{width:28px;height:28px;}';
        styles += '.vt-group:hover{background-color:#09A3EF;}';
        styles += '.vt-group:active{background-color:#0CAAF2;}';
        styles += '.vt-group.selected{background-color:#67b2e8;}';
        styles += '.vt-group-ctn{display:none;position:absolute;bottom:50px;left:0;}';
        styles += '.vt-group-ctn.selected{display:table;}';
        styles += '.vt-group-ctn .vt-item-cmd,.vt-group-ctn .vt-item-toggle{display:table;}';
        styles += '.vt-group-ctn >*:first-child{border-top-left-radius:6px;border-top-right-radius:6px;}';
        styles += '.vt-group-ctn >*:last-child{border-bottom-left-radius:6px;border-bottom-right-radius:6px;}';

        //styles += '.vt-main-ctn,.vt-2d-main-ctn{background-size:50px 50px;background-image:linear-gradient(0deg,transparent 24%,rgba(0,0,255,.25) 25%,rgba(0,0,255,.25) 26%,transparent 27%,transparent 74%,rgba(0,0,255,.25) 75%,rgba(0,0,255,.25) 76%,transparent 77%,transparent),linear-gradient(90deg,transparent 24%,rgba(0,0,255,.25) 25%,rgba(0,0,255,.25) 26%,transparent 27%,transparent 74%,rgba(0,0,255,.25) 75%,rgba(0,0,255,.25) 76%,transparent 77%,transparent);}';
        styles += '.vt-main-ctn *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;}';
        styles += '.vt-2d-main-ctn{background-color:#fff;}';

        styles += '.vt-menu-arrow{position: absolute;z-index:1;top:0;right:0;}';
        styles += '.vt-menu-arrow::after{content:" ";font-size:0;line-height:0;width:0;height:0;border-left:13px solid transparent;border-top:13px solid #dbdee2;position:absolute;top:0;right:0;}';
        styles += '.vt-item,.vt-item img{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}';

        styles += '.vt-settings-menu{width:275px;position: absolute;left:207px;bottom:52px;border-radius:5px;background-color:#0A8FCC;padding:10px;display:none;line-height:1;}';
        styles += '.menu-title{color:#e3e3e3;font-size:0.875em;}';
        styles += '.vt-settings-menu .exit-btn{float:right;color:#afb6bf;}';
        styles += '.exit-btn:hover{cursor:pointer;}';
        styles += '.radio-btn{margin-right:5px}';
        styles += '.vt-settings-menu label{font-weight:400;line-height:1;margin-bottom:0;}';
        styles += '.menu-section{position:relative;margin:20px 0;padding: 10px;color:#e3e3e3;font-size:0.875em;border:1px solid #afb6bf;}';
        styles += '.menu-section label{width:50%;}';
        styles += '.menu-section label:nth-of-type(odd){text-align:left;}';
        styles += '.menu-section label:nth-of-type(even){text-align:right;}';
        styles += '.menu-section-title{position:absolute;left:20px;top:-8px;padding:0px 5px;background-color:#0A8FCC;}';
        styles += '.drop-down{width:100%;background-color:#0A8FCC;}';
        styles += '.vt-settings-menu .e-colorpicker-wrapper{height:32px;}';
        styles += '.vt-settings-menu .e-colorpicker-wrapper .e-split-btn-wrapper{height:32px;}';
        styles += '.vt-settings-menu .e-colorpicker-wrapper .e-split-colorpicker{width:32px;height:32px;padding:0 5px;}';
        styles += '.vt-settings-menu .e-colorpicker-wrapper .e-dropdown-btn{width:20px;height:32px;}';

        styles += '.menu-section-tr{display:flex;}';

        styles += '.vt-settings-menu.selected{display:block;}';

        styles += '.arrow{border: solid black;border - width: 0 3px 3px 0;display: inline - block;padding: 3px;}';
        styles += '.up {transform: rotate(-135deg);-webkit - transform: rotate(-135deg);}';
        styles += '.down {transform: rotate(45deg);-webkit - transform: rotate(45deg);}';
        styles += '.arrow-down{border: solid black;border-width: 0 3px 3px 0;display: inline-block;padding: 3px;transform: rotate(-135deg);-webkit-transform: rotate(-135deg);}';
        styles += '.arrow-up{border: solid black;border-width: 0 3px 3px 0;display: inline-block;padding: 3px;transform: rotate(45deg);-webkit-transform: rotate(45deg);}';

        //Toolbar end

        //Status menu
        styles += '.vs-main-status{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;'+
                '-webkit-box-align:center;-moz-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;' +
                '-webkit-box-pack:center;-moz-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;' +
                'position:absolute;width:100%;color: #f1f2f4;pointer-events:none;}';
        styles += '.vs-main-status-ctnt{width:370px;padding:10px;font-size:0.875em;text-align:center;z-index:11;}';
        styles += '.vs-progress-bar{position:relative;display:inline-block;width:250px;height:25px;background-color:#FFFFFF;border: 2px solid #0a8fcc;}';
        styles += '.vs-progress-status{position:absolute;top:0;height:100%;background-color:#dceaf7;width:0%;}';
        styles += '.vs-loading-text{position:relative;width:100%;z-index:1;color:#202428;text-align:center;line-height:20px;}';
        //Status menu end

        // Zoom/Track Focus Slider
        styles += '.zoom-widget{display:none;position:absolute;width:33px;z-index:10;border:1px solid #bac0c8;border-radius:5px;}';
        styles += '.slider-zoom-btn{position:relative;display:block;width:100%;height:20px;border:0px;background-color:#0A8FCC;}';
        styles += '.slider-zoom-btn:focus, .zoom-out-btn:focus{outline:0;}';
        styles += '.slider-zoom-btn img{position:absolute;top:3.5px;left:8.5px;width:13px;}';
        styles += '.zoom-slider{position:relative;height:219px;width:100%}';
        styles += '.zoom-slider-grabber{display:block;width:26px;height:8px;position:relative;top:106px;left:2px;background-color:#2785c7;opacity: 0.90;border:1px solid #2785c7;border-radius:5px;text-align:center;}';
        styles += '.zoom-slider-grabber:before{position:absolute;content:"";top:-10px;right:-15px;left:-15px;bottom:-12px;}';
        styles += '.zoom-slider-grabber:hover{cursor:-webkit-grab;text-decoration:none;cursor:grab;}';
        styles += '.zoom-slider-grabber:active{cursor:-webkit-grabbing;cursor:grabbing;}';
        // Zoom/Trach Focus Slider end
        styles += '.unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}';

        styles += '.num-slider{pointer-events:all;width:100%;position:relative;}'
        styles += '.num-slider .num-slider-bar{width:calc(100% - 55px);height:19px;display:inline-block;margin-right:10px;}';
        styles += '.num-slider .num-slider-bar::before{position:absolute;content:"";background-color:white;border:1.5px solid white;width:calc(100% - 74px);margin:8px 9.5px;}';
        styles += '.num-slider .num-slider-bar .num-slider-grabber{background-color:#858c96;width:19px;height:19px;position:absolute;border-radius:50%;cursor:-webkit-grab;}';
        styles += '.num-slider .num-slider-bar .num-slider-grabber.grabbing{cursor:-webkit-grabbing;}';
        styles += '.num-slider >input{width:45px;height:19px;font-size:12px;vertical-align:top;display:inline-block;}';

        styles += '.fov-popup-content{margin-top:10px;color:#e3e3e3;font-size:0.875em;}';
        styles += '.fov-slider-wrapper{margin-left:5px;margin-right:5px;}';
        styles += '.fov-slider-labels{margin-top:10px;display:flex;justify-content:space-between;}';
        styles += '.fov-slider-label{cursor:pointer;}';
        
        if (!document.getElementById('css-mgr-tbmg')) {
            var style = document.createElement('style');
            style.id = 'css-mgr-tbmg';
            style.innerHTML = styles;

            document.head.appendChild(style);
        }
    }
}

export default CssManager;